import { Injectable } from '@angular/core';
import { DeviceSession, IUserDevice } from './device-sessions.types';

@Injectable({
    providedIn: 'root',
})
export class DeviceSessionsService {
    userDevices: Readonly<IUserDevice>[] | null = null;
    deviceSessions: DeviceSession[] | null = null;

    reset(): void {
        this.userDevices = null;
        this.deviceSessions = null;
    }
}
